import noop from 'lodash-es/noop';
import { History } from 'history';
import { useChangeRoute } from './useChangeRoute';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export type DialogType = 'bottomsheet' | 'spoke' | 'sidepane';

/**
 * Hook which automatically pushes and pops a route for a dialog using react router
 * @param dialogType The dialog type
 * @param onCloseDialog Callback to be triggered on close of the dialog
 */
export const useDialogRoute = (dialogType: DialogType, onCloseDialog: () => void) => {
    const history: History = useHistory();
    const location: { pathname: string } = useLocation();
    const { goBack } = useChangeRoute();

    useEffect(() => {
        if (!dialogType) {
            return noop;
        }

        let shouldPop = true;

        // Push dialog path to history
        const dialogPath = `${location.pathname}/${dialogType}`;
        history.push({
            ...location,
            pathname: dialogPath,
        });

        // Listen to history changes and don't pop if the pop or replace action is already done
        const unregisterCallback = history.listen((location, action) => {
            if (action === 'POP' || action === 'REPLACE') {
                shouldPop = false;
                onCloseDialog();
            }
        });

        return () => {
            // Go back in history when unmounting only if the user didn't already pop using using back button
            shouldPop && goBack();
            unregisterCallback();
        };
    }, [dialogType]);
};
